import React from "react";
import { Icon, addManager, notFound } from "Icons/index";
import s from "./emptyListIcon.scss";

const EmptyListIcon = ({ isNotFound = false, title = null, message = null, svg = addManager }) => (
  <div className={s.noFoundMsg}>
    <div className={s.wrapIllustration}>
      <Icon svg={isNotFound ? notFound : svg} width="10rem" height="10rem" />
      {title && <div className={s.msgIllustration}>{title}</div>}
      {message && <div className={s.descIllustration}>{message}</div>}
    </div>
  </div>
);

export default EmptyListIcon;
